const STORAGE_KEY = 'accountSetupAuthorizeEnvironment';

const normalizeEnvironment = (value) => {
  if (!value) return null;
  const normalized = String(value).trim().toUpperCase();
  if (normalized === 'SANDBOX' || normalized === 'PRODUCTION') {
    return normalized;
  }
  return null;
};

const getDefaultEnvironment = () => {
  const fromEnv = normalizeEnvironment(process.env.REACT_APP_AUTHORIZE_ENVIRONMENT);
  if (fromEnv) return fromEnv;
  return process.env.NODE_ENV === 'development' ? 'SANDBOX' : 'PRODUCTION';
};

export const getAuthorizeEnvironment = () => {
  if (process.env.NODE_ENV === 'production') {
    return 'PRODUCTION';
  }

  try {
    const stored = normalizeEnvironment(localStorage.getItem(STORAGE_KEY));
    if (stored) return stored;
  } catch {
    // localStorage may be unavailable
  }

  return getDefaultEnvironment();
};

export const setAuthorizeEnvironment = (env) => {
  const normalized = normalizeEnvironment(env);
  if (!normalized) return;

  try {
    localStorage.setItem(STORAGE_KEY, normalized);
  } catch {
    // ignore storage failures
  }
};

export const getSubscriptionAuthorizeEnvironment = (subscription) => {
  const stored =
    subscription?.authorizeEnvironment
    || subscription?.metadata?.authorizeEnvironment;
  if (stored === 'SANDBOX' || stored === 'PRODUCTION') {
    return stored;
  }
  return getAuthorizeEnvironment();
};

export const isAuthorizeSandbox = () => getAuthorizeEnvironment() === 'SANDBOX';

export default {
  getAuthorizeEnvironment,
  setAuthorizeEnvironment,
  getSubscriptionAuthorizeEnvironment,
  isAuthorizeSandbox,
};
